export default __webpack_public_path__ + "static/media/Shopify_logo.a70fc227.svg";